import { BookingInfo } from './../../../interfaces/my-reservation.model';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MatError,
  MatFormField,
  MatOption,
  MatSelect,
} from '@angular/material/select';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { API_PARAMS } from '../../../constants/api.constants';
import {
  AppointmentInfoField,
  BusinessCheckupSettingsRequest,
  PersonalCheckupSettingsRequest,
} from '../../../interfaces/appointment-info.model';
import { ModifyExamDietDialogModel } from '../../../interfaces/dialogs/modify-exam-diet-dialog.model';
import { AppointmentInfoService } from '../../../services/appointment-info.service';
import { SharedStorageService } from '../../../services/shared-storage.service';
import { ID_LOGIN_TYPE } from '../../../constants/common.constants';
import { ExamItemName } from '../../../interfaces/reserve-confirm-survey.model';
import { AddExamInfo } from '../../../interfaces/reserve-add.model';

/**
 * 修改健檢餐食dialog組件
 */
@Component({
  selector: 'app-modify-exam-diet-dialog',
  standalone: true,
  imports: [
    TranslatePipe,
    MatButton,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    FormsModule,
    MatError,
    MatFormField,
    NgClass,
    NgOptimizedImage,
  ],
  templateUrl: './modify-exam-diet-dialog.component.html',
  styleUrl: './modify-exam-diet-dialog.component.scss',
})
export class ModifyExamDietDialogComponent implements OnInit {
  showFormError: boolean = false; // 是否顯示表單錯誤
  breakfasts: Array<AppointmentInfoField> = []; // 早餐選項
  lunches: Array<AppointmentInfoField> = []; // 午餐選項
  breakfast: string = ''; // 早餐
  lunch: string = ''; // 午餐
  form = new FormGroup({
    breakfast: new FormControl('', [Validators.required]), // 早餐
    lunch: new FormControl('', [Validators.required]), // 午餐
  });

  constructor(
    public dialogRef: MatDialogRef<ModifyExamDietDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModifyExamDietDialogModel,
    private sharedStorageService: SharedStorageService,
  ) {}

  ngOnInit(): void {
    // 直接使用傳入的資料
    this.breakfasts = this.data.breakfasts ?? [];
    this.lunches = this.data.lunches ?? [];
    
    // 設定表單初始值
    this.form.get('breakfast')?.setValue(this.data.breakfast ?? '');
    
    // 只有當有午餐選項時才設定為必填
    if (this.lunches.length > 0) {
      this.form.get('lunch')?.setValidators([Validators.required]);
      this.form.get('lunch')?.setValue(this.data.lunch ?? '');
    } else {
      this.form.get('lunch')?.clearValidators();
    }
    
    this.form.updateValueAndValidity();
  }

  // 關閉dialog
  closeDialog() {
    this.dialogRef.close(null);
  }

  // 提交修改
  onSubmit() {
    this.showFormError = true;
    if (this.form.valid) {
      const formValue = this.form.value;

      //重抓一次中文
      this.breakfast =
        this.breakfasts.find(item => item.uno === formValue.breakfast)?.noDesc ?? '';
      this.lunch =
        this.lunches.find(item => item.uno === formValue.lunch)?.noDesc ?? '';

      const submitValue = {
        ...formValue,//代號
        breakfastDesc: this.breakfast,//中文
        lunchDesc: this.lunch,//中文
      };
      console.log("submitValue:",submitValue)
      this.dialogRef.close(submitValue as ModifyExamDietDialogModel);
    }
  }
}
